import React, { useState } from "react";
import Chevron from "../../assets/images/common/chevron-right.svg";
import DataTable from "../../components/patients/allpatients/DataTable";
import "../../assets/css/patients/allpatients/allpatientsheader.scss";
import Searchbar from "../../components/common/Searchbar";



const AllPatients = () => {
  const [rows, setRows] = useState([
    {
      number: 1,
      name: "Sufian",
      age: 35,
      gender: "male",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      civilID: "321",
      visitDate: "20th Dec 2022",
      visitTime: "8:20 am",
    },
    {
      number: 2,
      name: "John Doe",
      age: 35,
      gender: "male",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      civilID: "Civil ID ",
      visitDate: "20th Dec 2022",
      visitTime: "8:20 am",
    },
    {
      number: 3,
      name: "John Doe",
      age: 35,
      gender: "male",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      civilID: "Civil ID ",
      visitDate: "20th Dec 2022",
      visitTime: "8:20 am",
    },
    {
      number: 4,
      name: "John Doe",
      age: 35,
      gender: "male",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      civilID: "Civil ID ",
      visitDate: "20th Dec 2022",
      visitTime: "8:20 am",
    },
    {
      number: 5,
      name: "John Doe",
      age: 35,
      gender: "male",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      civilID: "Civil ID ",
      visitDate: "20th Dec 2022",
      visitTime: "8:20 am",
    },
    {
      number: 6,
      name: "John Doe",
      age: 35,
      gender: "male",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      civilID: "Civil ID ",
      visitDate: "20th Dec 2022",
      visitTime: "8:20 am",
    },
    {
      number: 7,
      name: "John Doe",
      age: 35,
      gender: "male",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      civilID: "Civil ID ",
      visitDate: "20th Dec 2022",
      visitTime: "8:20 am",
    },
  ]);
  const [searchQuery, setSearchQuery] = useState("");

  // Search Functionality
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  return (
    <>
      <div className="row pl-3 pr-2 pt-4 allpatient-tab">
        <div className="col-12">
          <p className="mb-0 allpatient-heading">Patients List</p>
        </div>

        <div className="col-12 my-4">
          <div className="row ">
            <div className="col-md-12">
              <p className="allpatient-breadcrumb">
                <span>DASHBOARD</span>
                <img src={Chevron} />
                <span> PATIENTS</span>
                <img src={Chevron} />
                <span className="current-tab"> ALL PATIENTS</span>
              </p>
            </div>
          </div>
          <div className="row m-0 p-0">
            <Searchbar onChange={handleSearchChange} value={searchQuery} />
          </div>
        </div>

        <div className="col-12 mb-5 pb-5">
          <DataTable rows={rows} searchQuery={searchQuery} />
        </div>
      </div>
    </>
  );
};

export default AllPatients;
